const WebPage = [{
  "_id": {
    "$oid": "68c161145e8a147bcf0644dd"
  },
  "symbol": "⚖️",
  "type": "chapterwiseweightage",
  "subject": "chemistry",
  "name": "2025 Physics Weightage\t",
  "link": "neet-chemistry-weightage",
  "__v": 0
},
{
  "_id": {
    "$oid": "68c1626e5e8a147bcf064551"
  },
  "symbol": "⚖️",
  "type": "chapterwiseweightage",
  "subject": "physics",
  "name": "2025 Physics Weightage",
  "link": "neet-physics-weightage",
  "__v": 0
},
{
  "_id": {
    "$oid": "68c162c55e8a147bcf064576"
  },
  "symbol": "⚖️",
  "type": "chapterwiseweightage",
  "subject": "biology",
  "name": "2025 Biology Weightage",
  "link": "neet-biology-weightage",
  "__v": 0
},
{
  "_id": {
    "$oid": "68c5abdfdd55e6bfa66dc891"
  },
  "symbol": "\t⚖️",
  "type": "chapterwiseweightage",
  "subject": "biology",
  "name": "2020 to 2024 Biology Weightage",
  "link": "all-neet-biology-weightage",
  "__v": 0
},
{
  "_id": {
    "$oid": "68c5aca3dd55e6bfa66dc898"
  },
  "symbol": "\t⚖️",
  "type": "chapterwiseweightage",
  "subject": "chemistry",
  "name": "2020 to 2024 Chemistry Weightage",
  "link": "all-neet-chemistry-weightage",
  "__v": 0
},
{
  "_id": {
    "$oid": "68c5acbfdd55e6bfa66dc89b"
  },
  "symbol": "\t⚖️",
  "type": "chapterwiseweightage",
  "subject": "physics",
  "name": "2020 to 2024 Physics Weightage",
  "link": "all-neet-physics-weightage",
  "__v": 0
}] 



export default WebPage;